import type { SUMMARY_ROUTE } from 'cpool-constants';
import { type Resolver, schemaUserCategories, teamCategory } from 'cpool-schemas';
import { z } from 'zod';

import { PartnersTableBaseZod } from '../../partner/tables';
import { LoanRequestsTableDefinitionZod, NotesTableDefinitionZod } from '../tables';
import type { LeadsFilter } from './shared/types';
import { schemaUserResolver_GetAclPermissions } from '../../user/resolvers/getAclPermissions';

type Arguments = {
    filters?: LeadsFilter;
    position?: number;
    status?: string;
    subStatus?: string;
    route?: SUMMARY_ROUTE;
    permissionsActionFilter?: Record<string, string[]>;
    [key: string]: unknown;
};

// we need to override the antragsteller1 field to be required as this resolver already checks if it exists
export const schemaLoanRequestResolver_GetSummaryItem = LoanRequestsTableDefinitionZod.omit({
    antragsteller1: true,
}).merge(
    z.object({
        // NOTE: make antragsteller1 required
        antragsteller1: LoanRequestsTableDefinitionZod.shape.antragsteller1.unwrap(),
        applicant2DataProtectionAgreed: z.boolean().nullable().optional(),
        nextIKCategory: teamCategory.optional(),
        notes: NotesTableDefinitionZod.shape.notes.optional(),
        offerSummary: z
            .object({
                amountMax: z.number().nullable(),
                amountMin: z.number().nullable(),
                favored: z.number(),
                sent: z.number(),
                teaser: z.number(),
                total: z.number(),
            })
            .optional(),
        partnerData: PartnersTableBaseZod.pick({
            direct_partner_company_name: true,
            direct_partner_first_name: true,
            direct_partner_id: true,
            direct_partner_last_name: true,
            direct_partner_name: true,
            email: true,
            hgb84_level: true,
            hgb93_level_bf: true,
            hgb93_level_pk: true,
            hubspot_url: true,
            onboarding_status: true,
            partner_level: true,
            phone: true,
        }).optional(),
        permissions: schemaUserResolver_GetAclPermissions,
        schufaSummary: z.object({ schufaScore: z.string().optional() }).nullable().optional(),
        userCategories: schemaUserCategories.optional(),
    }),
);

export const schemaLoanRequestResolver_GetSummary = z.array(schemaLoanRequestResolver_GetSummaryItem);

export type SchemaLoanRequestResolver_GetSummary = z.infer<typeof schemaLoanRequestResolver_GetSummary>;

export type LoanRequestResolver_GetSummary = Resolver<Arguments, SchemaLoanRequestResolver_GetSummary>;
